<div class="upload-view-components" *ngIf="config">
    <div class="upload-view-components__header">
        <h2 class="component-title">{{ config.title }}</h2>
    </div>

    <div>
        <div class="upload-view-components__content">
            <div class="upload-view-components__content__upload-content">
                <!-- Single Tab Upload -->
                <div *ngIf="isSingleTab()">
                    <h3>
                        Importe o arquivo com os dados de
                        {{ singleTabConfig.file.title }}

                        <mb-icon
                            *ngIf="singleTabConfig.file.example"
                            icon="download"
                            (click)="downloadTemplateImportFile()"
                        ></mb-icon>
                    </h3>
                    <app-upload-file
                        (emitFiles)="getFile($event)"
                        (validationError)="handleErrors($event)"
                        (clearFiles)="clearFiles($event)"
                        (emitFilesDetails)="getFileDetail($event)"
                        (fileRemovedByIndex)="removeFileAtIndex($event)"
                        [fileTabName]="singleTabConfig.file.tabName"
                        [validationSchema]="singleTabConfig.file.schema"
                        [mapFileKeys]="singleTabConfig.file.mapFileKeys"
                        [parserFunction]="singleTabConfig.file.parserFunction"
                        [headerRow]="singleTabConfig.file.headerRow"
                        [multiple]="multiple"
                    ></app-upload-file>
                </div>

                <!-- Multi Tab Upload -->
                <div *ngIf="isMultiTab()">
                    <h3>
                        Importe o arquivo com os dados de
                        {{ multiTabConfig.title }}
                    </h3>
                    <app-upload-file-multi-tab
                        (emitFiles)="getFile($event)"
                        (validationErrors)="handleMultiTabErrors($event)"
                        (tabResults)="handleMultiTabResults($event)"
                        (clearFiles)="clearFiles($event)"
                        (emitFilesDetails)="getFileDetail($event)"
                        [tabConfigs]="multiTabConfig.fileTabs"
                    ></app-upload-file-multi-tab>
                </div>
            </div>

            <hr />

            <div
                class="upload-view-components__content__upload-result"
                [ngClass]="
                    !!this.file || !!this.multiTabErrors
                        ? 'display-flex'
                        : 'display-none'
                "
            >
                <div
                    class="upload-view-components__content__upload-result__header"
                >
                    <h3>Resultado</h3>
                </div>
                <div
                    class="upload-view-components__content__upload-result__logs"
                >
                    <div
                        class="upload-view-components__content__upload-result__logs__content"
                        *ngIf="!file && !multiTabErrors"
                    >
                        <div
                            class="upload-view-components__content__upload-result__logs__content__header"
                        >
                            <h3>Anexe algum arquivo!</h3>
                        </div>
                    </div>

                    <!-- Errors (Single and Multi-Tab) -->
                    <div
                        class="upload-view-components__content__upload-result__logs__content"
                        *ngIf="multiTabErrors"
                    >
                        <div
                            class="upload-view-components__content__upload-result__logs__content__header"
                        >
                            <h3>
                                {{ isMultiTab() ? 'Erros nas Abas' : 'Erros' }}
                            </h3>
                        </div>
                        <div
                            class="upload-view-components__content__upload-result__logs__content__show-errors"
                        >
                            <div
                                *ngFor="
                                    let tabError of multiTabErrors | keyvalue
                                "
                            >
                                <h4 *ngIf="isMultiTab()">
                                    <b>Aba "{{ tabError.key }}":</b>
                                </h4>
                                <div
                                    class="upload-view-components__content__upload-result__logs__content__show-errors__line"
                                    *ngFor="
                                        let error of tabError.value
                                            | keyValueSort
                                    "
                                >
                                    <span>
                                        <b>
                                            Linha
                                            {{ error.key | xlsxLineError }}:
                                        </b>
                                    </span>
                                    <div
                                        class="upload-view-components__content__upload-result__logs__content__errors__field"
                                        *ngFor="let e of error.value"
                                    >
                                        <p>
                                            <b>Campo:</b>
                                            {{
                                                getXlsxColumnName(
                                                    e.path[1],
                                                    tabError.key
                                                )
                                            }}
                                        </p>
                                        <p>
                                            <b>Erro:</b>
                                            {{ e.message }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        class="upload-view-components__content__upload-result__logs__content"
                        *ngIf="validationError"
                    >
                        <div
                            class="upload-view-components__content__upload-result__logs__content__header"
                        >
                            <h3>Erro de Validação</h3>
                        </div>
                        <div
                            class="upload-view-components__content__upload-result__logs__content__show-errors"
                        >
                            <p>{{ validationError }}</p>
                        </div>
                    </div>
                    <div
                        class="upload-view-components__content__upload-result__logs__content"
                        *ngIf="file && !multiTabErrors && !validationError"
                    >
                        <div
                            class="upload-view-components__content__upload-result__logs__content__header"
                        >
                            <h3>Planilha importada com sucesso!</h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="upload-view-components__content__upload-action">
            <mb-button [disabled]="isDisabledButton()" (click)="saveFile()">
                Salvar
            </mb-button>
        </div>
    </div>
</div>
<ng-template #noResult>
    <div class="content">
        <span>Faça o upload do arquivo!</span>
    </div>
</ng-template>
